import { useField } from 'react-final-form';

import { MailKeys } from '@stores/settingsStore/constants';

type OnChangeKeys =
  | 'onChangeMailHost'
  | 'onChangeMailPort'
  | 'onChangeMailUserName'
  | 'onChangeMailPassword'
  | 'onChangeMailAuthEnable'
  | 'onChangeMailStarttlsEnable'
  | 'onChangeMailSslEnable'
  | 'onChangeMailSenderName'
  | 'onChangeMailUrl'
  | 'onChangeTransportProtocol';

export const useFieldMail = (
  fieldNamesByCheckbox: Record<string, string>,
): { [key in OnChangeKeys]: (v: unknown) => void } => {
  const {
    input: { onChange: onChangeMailHost },
  } = useField(fieldNamesByCheckbox[MailKeys.host]);
  const {
    input: { onChange: onChangeMailPort },
  } = useField(fieldNamesByCheckbox[MailKeys.port]);
  const {
    input: { onChange: onChangeMailUserName },
  } = useField(fieldNamesByCheckbox[MailKeys.username]);
  const {
    input: { onChange: onChangeMailPassword },
  } = useField(fieldNamesByCheckbox[MailKeys.password]);
  const {
    input: { onChange: onChangeMailAuthEnable },
  } = useField(fieldNamesByCheckbox[MailKeys.authEnable]);
  const {
    input: { onChange: onChangeMailStarttlsEnable },
  } = useField(fieldNamesByCheckbox[MailKeys.starttlsEnable]);
  const {
    input: { onChange: onChangeMailSslEnable },
  } = useField(fieldNamesByCheckbox[MailKeys.sslEnable]);
  const {
    input: { onChange: onChangeMailSenderName },
  } = useField(fieldNamesByCheckbox[MailKeys.senderName]);
  const {
    input: { onChange: onChangeMailUrl },
  } = useField(fieldNamesByCheckbox[MailKeys.url]);
  const {
    input: { onChange: onChangeTransportProtocol },
  } = useField(fieldNamesByCheckbox[MailKeys.transportProtocol]);

  return {
    onChangeMailHost,
    onChangeMailPort,
    onChangeMailUserName,
    onChangeMailPassword,
    onChangeMailAuthEnable,
    onChangeMailStarttlsEnable,
    onChangeMailSslEnable,
    onChangeMailSenderName,
    onChangeMailUrl,
    onChangeTransportProtocol,
  };
};
